import SectionMessage from '@atlaskit/section-message';

import React from 'react';

import t from 'modules/i18n/intl';

const link = (chunks) => (
  <a href="https://app.opsgenie.com/billing" target="_blank" rel="noopener noreferrer">
    {chunks}
  </a>
);

export const OpsgenieActionMessage = () => (
  <SectionMessage>
    {t(
      {
        id: 'mac.licenses.opsgenie-billed-separately',
        defaultMessage:
          'Opsgenie is billed separately. Please go <link>here</link> to change plans or update your Opsgenie payment details.',
      },
      {
        link,
      },
    )}
  </SectionMessage>
);
